<template>
  <system-custom-notifications-step>
    <template v-slot:content>
      <talent-filtering key="talent-filtering-custom-notifications"/>
    </template>
    <template v-slot:sidebar>
      <h2>Selected {{ $starLabelPlural | sentenceCase }}</h2>
      <input v-model="search" placeholder="Filter..."/>
      <DynamicScroller
        :items="filteredSelectedStars"
        class="scroller"
        :min-item-size="30"
        key-field="id">
        <template v-slot="{ item, active }">
          <DynamicScrollerItem
            :item="item"
            :active="active"
            :size-dependencies="[item.name]">
            <button class="user" @click="handleRemoveTalentCallback(item)">
              {{ item.name }} <i class="fa fa-times" @click="handleRemoveTalentCallback(item)"></i>
            </button>
          </DynamicScrollerItem>
        </template>
      </DynamicScroller>
    </template>
  </system-custom-notifications-step>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TalentFiltering from '../misc/TalentFiltering'
import SystemCustomNotificationsStep from './SystemCustomNotificationsStep'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'

export default {
  components: {
    TalentFiltering,
    DynamicScroller,
    DynamicScrollerItem,
    SystemCustomNotificationsStep
  },

  data () {
    return {
      search: ''
    }
  },

  computed: {
    ...mapState('filtering', ['selectedStars']),

    filteredSelectedStars () {
      if (this.search.length) {
        return this.selectedStars.filter(element => element.name.toLowerCase().includes(this.search.toLowerCase()))
      }
      return this.selectedStars
    }
  },

  methods: {
    ...mapActions('notification', ['nextPage', 'lastPage']),
    ...mapActions('filtering', ['removeSelectedStar']),

    /**
       * Handle removing talent from the array of additional talent.
       *
       * @return void
       */
    handleRemoveTalentCallback (talent) {
      this.removeSelectedStar(talent.id)
    }
  }
}
</script>

<style scoped>
  .scroller {
    height: 100%;
    max-height: 55vh;
    overflow-y: scroll;
    overflow-x: hidden;
  }
  .user {
    background-color: white;
    border: none;
    padding: 1px 0px;
  }
</style>
